import { render, staticRenderFns } from "./OfflineTrashPage.vue?vue&type=template&id=25d99f56"
import script from "./OfflineTrashPage.vue?vue&type=script&lang=js"
export * from "./OfflineTrashPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports